import { render, staticRenderFns } from "./withheldDetails.vue?vue&type=template&id=6f7f2ac2&"
import script from "./withheldDetails.vue?vue&type=script&lang=js&"
export * from "./withheldDetails.vue?vue&type=script&lang=js&"
import style0 from "./withheldDetails.vue?vue&type=style&index=0&id=6f7f2ac2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports